// extracted by mini-css-extract-plugin
module.exports = {"margin":"Features_margin__2dOZi","container":"Features_container__23CUe"};